// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductDetailsCtaMobileProductData-module-productName-rQNZC{font-size:14px;line-height:20px;font-weight:var(--weight-bold);overflow:hidden;text-overflow:ellipsis}.ProductDetailsCtaMobileProductData-module-productPrice-UxBnj{font-size:14px;font-weight:var(--weight-medium);letter-spacing:1.5px;line-height:20px}", ""]);
// Exports
exports.locals = {
	"productName": "ProductDetailsCtaMobileProductData-module-productName-rQNZC",
	"productPrice": "ProductDetailsCtaMobileProductData-module-productPrice-UxBnj"
};
module.exports = exports;
